// extracted by mini-css-extract-plugin
module.exports = {"loading-icon":"svg-loading_loading-icon__iuNxN","adm-spin-loading-rotate":"svg-loading_adm-spin-loading-rotate__kQAiQ"};